/**
 * /app/$tenantSlug/settings/notifications — old home of the notification
 * preferences. N1 (2026-10-21): the page is now the Notifications tab of
 * Me → Account (reachable by every role); this route only redirects so
 * bookmarks, emails and old links keep working.
 */

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/settings/notifications",
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/app/$tenantSlug/me/account/notifications",
      params: { tenantSlug: params.tenantSlug },
      replace: true,
    });
  },
});
